<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header">
          <div class="row">
            <div class="col">
              <i class="fas fas-align-justify"></i>
              Orders
            </div>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-11">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <input class="form-control" placeholder="Search" [(ngModel)]="searchCriteria.query"
                             (change)="getQuotes()">
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group">
                      <input class="form-control" placeholder="Search on Plot" [(ngModel)]="searchCriteria.plot"
                             (change)="getQuotes()">
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group">
                      <input class="form-control" placeholder="Search on Park" [(ngModel)]="searchCriteria.park"
                             (change)="getQuotes()">
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group">
                      <input class="form-control" placeholder="Search on Lead/Contract"
                             [(ngModel)]="searchCriteria.leadContractNumber" (change)="getQuotes()">
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group">
                      <input class="form-control" placeholder="Search on Plaque"
                             [(ngModel)]="searchCriteria.serialNumber" (change)="getQuotes()">
                    </div>
                  </div>
                  <div class="col">
                    <ng-select placeholder="Status"
                               [items]="statuses"
                               bindLabel="name"
                               bindValue="id"
                               [appearance]="'outline'"
                               [(ngModel)]="searchCriteria.status"
                               (change)="getQuotes()"
                    ></ng-select>
                  </div>
                </div>
              </div>
              <div class="col-1">
                <button class="btn btn-warning" (click)="clearFilter()">Clear Filter</button>
              </div>
            </div>
            <h3 *ngIf="!quotes.length">No quotes found</h3>
            <div *ngIf="quotes.length">
              <table class="table" [ts-wrapper]="searchCriteria" (sortChange)="this.getQuotes()">
                <thead>
                <tr>
                  <th ts-criteria="customerName">Plot</th>
                  <th ts-criteria="plotNumber">Park</th>
                  <th>Type</th>
                  <th ts-criteria="dateCreated">Created Date</th>
                  <th ts-criteria="createByUserId">Created By</th>
                  <th>Rep</th>
                  <th ts-criteria="contractNumber">Contract Number</th>
                  <th>From 365</th>
                  <th ts-criteria="status" class="text">Status</th>
                  <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let quote of quotes">
                  <td>{{ quote.plot }}</td>
                  <td>{{ quote.park }}</td>
                  <td>{{ quote?.fitrite365QuoteDetails?.quoteType }}</td>
                  <td>{{ quote.dateCreated | date:'dd/MM/yy HH:mm' }}</td>
                  <td>{{ quote.createdByUser?.firstName }} {{ quote.createdByUser?.lastName }}</td>
                  <td>{{ (quote?.customer?.rep?.firstName || '') + ' ' + (quote?.customer?.rep?.lastName || '') }}</td>
                  <td>{{ quote.contractNumber }}</td>
                  <td [ngClass]="quote.from365 ? 'text-success' : ''">{{ quote.from365 ? 'Yes' : 'No' }}</td>
                  <td>{{ quote.status }}</td>
                  <td>
                    <div class="btn-group">
                      <button
                        class="btn btn-primary dropdown-toggle"
                        type="button"
                        data-coreui-toggle="dropdown"
                        aria-expanded="false">
                        Actions
                      </button>

                      <ul class="dropdown-menu">
                        <li><a class="dropdown-item" [routerLink]="['/quotes', quote.id]">Details</a></li>
                        <li><a class="dropdown-item" *ngIf="quote.status == 'Fitted' || quote.status == 'Invoiced'" [routerLink]="['/createremedial', quote?.id]" >Create Remedial</a></li>
                        <li><a class="dropdown-item" *ngIf="quote.status == 'Fitted' || quote.status == 'Invoiced'" [routerLink]="['/quotes/createremoveandrefit', quote?.id]">Create Remove And Refit</a></li>
                      </ul>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-xs-12 col-12">
              <div class="d-flex justify-content-center" *ngIf="totalItems">
                <ngb-pagination
                  [collectionSize]="totalItems"
                  [(page)]="searchCriteria.pageNumber"
                  [pageSize]="searchCriteria.pageSize"
                  [maxSize]="6"
                  [boundaryLinks]="true"
                  (pageChange)="setPage($event)"
                  size="sm"
                  previousLabel="&lsaquo;"
                  nextLabel="&rsaquo;"
                  firstLabel="&laquo;"
                  lastLabel="&raquo;">
                </ngb-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
